import "./QastionsAnswers.scss";
import Accordion from "components/Accordion/Accordion";
import { Trans } from "react-i18next";
interface QastionsAnswersProps {
  questionsArr: {
    question: string;
    answer: string;
  }[];
  title: string;
}

const QastionsAnswers = ({ questionsArr, title }: QastionsAnswersProps) => {
  return (
    <div className="qa-block">
      <div className="qa-title">{title}</div>
      <div className="main-content">
        {questionsArr.map((question, index) => {
          return (
            <div className="qa-row" key={index}>
              {question.question === "question4" ? (
                <div className="question">
                  <Trans
                    i18nKey="FAQ.business.question4"
                    components={{
                      KYB: <a href="/KYB.pdf" target="_blank" />,
                    }}
                  />
                </div>
              ) : (
                <div className="question">{question.question}</div>
              )}
              <div className="answer">{question.answer}</div>
            </div>
          );
        })}
        <Accordion content={questionsArr} />
      </div>
    </div>
  );
};

export default QastionsAnswers;
